import { Position, State } from 'src/types'
// 背面の描画
import { indexFingerCover } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/fingerCoverOrPad/indexFingerCover'
import { lace } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/lace'
import { lining } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/lining'
import { littleHook } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/hooks/littleHook'
import { thumbHook } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/hooks/thumbHook'
import { backLaceDrawer, ragdelionLabelDrawerForGloveLeftThrow } from 'src/features/brands/ragdelion/canvas/common/useCanvasHelper'
import { webOfGloveBackDrawer } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/web/useCanvasWebsBack'
import { bottomRightOfBeltEmbroideryDrawer } from 'src/features/brands/ragdelion/canvas/common/back/useCanvasEmbroideries'
import { loopOfRingFinger } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/loopOfRingFinger'
import { ragLionEmbroidery } from 'src/features/brands/ragdelion/canvas/common/back/embroidery'
import { laceOfWristBeltCrossDrawer } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/back/lace/laceOfWristBeltFix'
// import { middleFingerCover } from 'src/features/brands/ragdelion/canvas/glove/back/fingerCoverOrPad/middleFIngerCover'
import { canvasResetter } from 'src/features/brands/ragdelion/canvas/common/canvasResetter'
import { backStyleChecker } from 'src/util/useModelDesign'
import { liningEmbroideryDrawerLeftThrow, nonThumbEmbroideryDrawerLeftThrow, startInversion, undoInversion } from 'src/util/canvas'
import { backStyleOfGloveBackDrawerLeftThrow } from './backStyles'
import { indexFingerCoverTipOut } from '../../rightThrow/back/fingerCoverOrPad/indexFingerCoverTipOut'

const getFingerGuardPositionCoordinate = (position: string) => {
  switch (position) {
    case 'onIndex':
      return { x: 0, y: 0, numerator: 0 }
    case 'onIndexLeft':
      return { x: -20, y: 5, numerator: 0 }
    case 'onFingerCrotch':
      return { x: -65, y: 40, numerator: -5 }
    case 'onMiddleRight':
      return { x: -110, y: 63, numerator: -9 }
    case 'onMiddle':
      return { x: -140, y: 65, numerator: -10 }
    default:
      return { x: 0, y: 0, numerator: 0 }
  }
}

export const ragdelionCanvasGloveBackLeftThrow = (ctx: CanvasRenderingContext2D, state: State, position: Position, canvasWidth: number): void => {
  const isSUN01L = state.baseModel?.productNumber === 'SUN-01L'
  const isIndexFingerCover =
    !isSUN01L && (state.fingerGuardType?.value == 'indexCover' || (state.fingerGuardType?.value === 'unselected' && position === 'pitcher'))
  const { isFirstBackStyle } = backStyleChecker(state.backStyle?.value)
  const needCatchFaceWrap = (!state.baseModel?.isUBack && !isFirstBackStyle) || false
  // リセット
  canvasResetter(ctx)

  startInversion(ctx, canvasWidth)
  // 裏革
  lining(ctx, state.linings?.color)
  // 薬指リング // カラー指定どうするか
  if (state.loopOfRingFinger?.value === 'loopOfRingFinger') {
    loopOfRingFinger(ctx, state?.loopOfRingFingerColor?.color, state.stitch.color)
  }
  undoInversion(ctx, canvasWidth)
  // ragdelionライオン描画
  ragLionEmbroidery(ctx, state.ragLionLogo.value, state.ragLionLogoColor.color, 10, 40)

  // 平裏の刺繍描画1段目
  liningEmbroideryDrawerLeftThrow(ctx, state.embroideries, 'first')
  // 平裏の刺繍描画2段目
  liningEmbroideryDrawerLeftThrow(ctx, state.embroideries, 'second')

  // バックスタイルの描画(ハミダシ,親指刺繍含)
  backStyleOfGloveBackDrawerLeftThrow(ctx, state, needCatchFaceWrap, canvasWidth)

  startInversion(ctx, canvasWidth)
  // 指カバー
  const fingerGuardPosition = state.fingerGuardPosition?.value
  const { x, y, numerator } = getFingerGuardPositionCoordinate(state.fingerGuardPosition?.value)
  const indexCoverColor = state.indexCover.color
  const stitchColor = state.stitch.color
  if (isIndexFingerCover) {
    switch (fingerGuardPosition) {
      case 'onIndex':
      case 'onMiddle':
        indexFingerCover(ctx, indexCoverColor, stitchColor, x, y, numerator)
        break
      case 'onIndexLeft':
      case 'onFingerCrotch':
      case 'onMiddleRight':
        indexFingerCoverTipOut(ctx, indexCoverColor, stitchColor, x, y, numerator)
        break
      default:
        indexFingerCover(ctx, indexCoverColor, stitchColor, 0, 0, 0)
        break
    }
  }
  undoInversion(ctx, canvasWidth)
  // RAG, Treasure＿ベルト右下への刺繍
  bottomRightOfBeltEmbroideryDrawer(ctx, state.embroideries, 40, 0)
  // 中指への刺繍
  nonThumbEmbroideryDrawerLeftThrow(ctx, 'middleFinger', state.embroideries)
  // 薬指への刺繍
  nonThumbEmbroideryDrawerLeftThrow(ctx, 'ringFinger', state.embroideries)
  // 小指への刺繍
  nonThumbEmbroideryDrawerLeftThrow(ctx, 'childFinger', state.embroideries)

  startInversion(ctx, canvasWidth)
  // ウェブの描画
  webOfGloveBackDrawer(ctx, state)
  // 革紐
  lace(ctx, state.lace?.color, state)
  if ([state.backStyle?.value, state?.baseModel?.backStyle].includes('firstBackStyle')) {
    laceOfWristBeltCrossDrawer(ctx, state.lace?.color, isFirstBackStyle)
  }
  // 背面紐通し(オプション)
  backLaceDrawer(ctx, state?.backLace?.value, state.lace?.color, position)

  // 小指掛け紐
  littleHook(ctx, state.littleHook?.color, 25, 240, -10, 0.7)
  // 親指掛け紐
  thumbHook(ctx, state.thumbHook?.color, 110, -310, 15) // 先端
  thumbHook(ctx, state.thumbHook?.color, -14, 30, 0) //手元

  undoInversion(ctx, canvasWidth)
  // ラベル描画
  ragdelionLabelDrawerForGloveLeftThrow(ctx, state)
}
